import React from "react";
import { Box, Typography, IconButton } from "@mui/material";
import { GitHub, LinkedIn } from "@mui/icons-material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGitlab } from "@fortawesome/free-brands-svg-icons";
import { useTranslation } from "react-i18next";
import HeaderData from "../data/HeaderData.json";

function Footer() {
  const { t } = useTranslation();

  return (
    <Box
      component="footer"
      sx={{
        py: { xs: 3, md: 4 },
        px: 2,
        textAlign: "center",
        borderTop: "1px solid rgba(99,102,241,0.1)",
        mt: { xs: 4, md: 6 },
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          gap: 0.5,
          mb: 1.5,
        }}
      >
        {[
          {
            href: HeaderData.github,
            icon: <GitHub fontSize="small" />,
            hoverColor: "#818cf8",
            label: "GitHub",
          },
          {
            href: HeaderData.gitlab,
            icon: <FontAwesomeIcon icon={faGitlab} />,
            hoverColor: "#fc6d26",
            label: "GitLab",
          },
          {
            href: HeaderData.linkedin,
            icon: <LinkedIn fontSize="small" />,
            hoverColor: "#0077b5",
            label: "LinkedIn",
          },
        ].map(({ href, icon, hoverColor, label }) => (
          <IconButton
            key={label}
            component="a"
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            size="small"
            aria-label={label}
            sx={{
              color: "text.secondary",
              "&:hover": {
                color: hoverColor,
                transform: "translateY(-3px)",
                bgcolor: "transparent",
              },
              transition: "all 0.2s ease",
            }}
          >
            {icon}
          </IconButton>
        ))}
      </Box>
      <Typography
        variant="body2"
        sx={{
          color: "text.secondary",
          fontSize: { xs: "0.78rem", sm: "0.8rem" },
          opacity: 0.6,
        }}
      >
        © {new Date().getFullYear()} Thomas Kammann &nbsp;·&nbsp;{" "}
        {t("footer.rights")}
      </Typography>
    </Box>
  );
}

export default Footer;
